import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import PageTitle from "../../Components/PageTitle"; 
import { ConfigContext } from "../../Context/ConfigContext"; 
import BasicInformation from "./BasicInformation";
import EmploymentInformation from "./EmploymentInformation";
import FamilyDetails from "./FamilyDetails";
// import OfficialDocuments from "./OfficialDocuments";
import BankDetails from "./BankDetails";
import PersonalDocuments from "./PersonalDocuments";
import { currentDateAndTime } from "../../Constants/constants";
import Swal from "sweetalert2";
import HolidayList from "./HolidayList";
import LazyImage from "../../Components/LazyImage";
// import SalaryDetails from "./SalaryDetails";
// import StatutoryDetails from "./StatutoryDetails";
import Select from 'react-select'


const UserProfileDetails = () => {
  const { apiURL, apiHeaderJSON,apiHeaderFile, employee_id } = useContext(ConfigContext);
  const [employeeBasicData, setEmployeeBasicData] = useState({});
  const[employeeMentData,setEmployeeMentData] = useState({});
  const[documentDetails,setDocumentDetails] = useState({});
  const[bankData,setBankData] = useState({});
  const[familyData,setFamilyData] = useState({});
  const [employeeOtherData, setEmployeeOtherData] = useState({});
  const [holidayYear, setHolidayYear] = useState(new Date().toISOString()?.split("T")[0]?.split("-")[0]);
  const [holidayList, setHolidayList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeComponent, setActiveComponent] = useState("BasicInformation");
  const [selectedFile, setSelectedFile] = useState(null);
  const [viewProfile, setViewProfile] = useState(false);
  const profileInfoOptions = [
    {value: "BasicInformation", label: "Basic Information",},
    {value: "EmploymentInformation", label: "Employment Information",},
    {value: "FamilyDetails", label: "Family Details",},
    // {value: "OfficialDocuments", label: "Official Documents",},
    // {value: "OtherPersonalDetails", label: "Other Personal Details",},
    {value: "BankDetails", label: "Bank Details",},
    {value: "PersonalDocuments", label: "Personal Documents",},
    {value: "HolidayList", label: "Holiday List",},
    // {value: "SalaryDetails", label: "Salary Details",},
    // {value: "StatutoryDetails", label: "Statutory Details",},
  ];

  useEffect(() => {
    getUser();
    getHolidayList();
    console.log(new Date().toISOString()?.split("T")[0]?.split("-")[0])
  }, []);

  const getEmployeeMaster = (mastersEmployeeData) => {
    const formData = {
      department_id: mastersEmployeeData.department_id,
      designation_id: mastersEmployeeData.designation_id,
      grade_id: mastersEmployeeData.grade_id,
      location_id: mastersEmployeeData.location_id,
    };

    axios
      .get(`${apiURL}Home/GetMastersEmployee`, {
        params: formData,
        headers: apiHeaderJSON,
      })
      .then((response) => {
        if (response.data.success) {
          setEmployeeOtherData(response.data.data);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const getUser = () => {
    setLoading(true);
    axios
      .get(`${apiURL}Home/GetProfile?employee_id=${employee_id}`, {
        headers: apiHeaderJSON,
      })
      .then((response) => {
        if (response.data.success) {
          const res = response.data.data;
          setEmployeeBasicData(res.employee);
          setEmployeeMentData(res.employee);
          setDocumentDetails(res.documents);
          setBankData(res.bank_data);
          setFamilyData(res.family_details);
          
          // setJoinDate(
          //   `${res.employee.employee_joining_date.split("-")[2]} ${
          //     res.employee.employee_joining_date.split("-")[1]
          //   } ${res.employee.employee_joining_date.split("-")[0]}`
          // );

          // const datejoin=setJoinDate(`${res?.employee?.employee_joining_date.split("-")[2]} ${monthData[parseInt(res?.employee?.employee_joining_date.split("-")[1])]} ${res?.employee?.employee_joining_date.split("-")[0]}`)
          // setJoinDate(datejoin)
           getEmployeeMaster(res.employee);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };
  const getHolidayList = () => {
    // setLoading(true);
    axios
      .get(`${apiURL}Home/GetMyHolidayList`, {
        params: {
          holiday_year: holidayYear,
        },
        headers: apiHeaderJSON,
      })
      .then((response) => {
        if (response.data.success) {
          const res = response.data.data;
          setHolidayList(res);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };


  const handleFileChange = (event) => {
    const file = event.target.files[0];
  
    if (file) {
      const maxSize = 1 * 1024 * 1024; 
  
      if (file.size > maxSize) {
        Swal.fire({
          title: "<strong>File Too Large</strong>",
          text: "Please upload an image smaller than 1 MB.",
          icon: "error",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
        return; 
      }
  
      setSelectedFile(file);
      uploadProfilePicture(file);
    }
  };
  
  
  const uploadProfilePicture = async (file) => {
    const formData = {
      file: file,
      date: currentDateAndTime(),
    };
   
  
    try {
      const response = await axios.post(
        `${apiURL}Home/UpdateProfile`, 
        formData, 
        {
          headers: apiHeaderFile,
        }
      );
  
      if (response.data.success) {
        // console.log("Profile picture updated successfully!", response.data);
        Swal.fire({
          title: "<strong>Success</strong>",
          text: "Successfully uploaded profile picture.",
          icon: "success",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      } else {
        console.error("Profile update failed:", response.data.message);
      }
    } catch (error) {
      console.error("Error uploading profile picture:", error);
    }
  };
  
  const renderComponent = () => {
    switch (activeComponent) {
      case "BasicInformation":
        return <BasicInformation employeeBasicData={employeeBasicData}  />;
      case "EmploymentInformation":
        return <EmploymentInformation employeeMentData={employeeMentData} />;
      case "FamilyDetails":
        return <FamilyDetails familyData={familyData} />;
      // case "OfficialDocuments":
      //   return <OfficialDocuments />;
      // case "OtherPersonalDetails":
      //   return <OtherPersonalDetails />;
        case "BankDetails":
        return <BankDetails bankData={bankData} />;
      case "PersonalDocuments":
        return <PersonalDocuments  documentDetails={documentDetails} />;
      case "HolidayList":
        return <HolidayList  holidayList={holidayList} />;
      // case "SalaryDetails":
      //   return <SalaryDetails />;
      // case "StatutoryDetails":
      //   return <StatutoryDetails />;
      default:
        return <BasicInformation />;
    }
  };

  return (
    <div>
      {!loading ? (
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <br />
              <PageTitle title="Overview" primary="My Details" />
              <div className="card mt-10">
                <div className="card-body p-4 text-center">
                  {/* <div className="profile-user position-relative d-inline-block mx-auto mb-4">
                    <img
                      src={employeeBasicData?.employee_profile_url || "assets/profile-pic.png"}
                      className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                      alt="user-profile-picture"
                    />
                  </div> */}
                  <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                  {/* <img
                      src={employeeBasicData?.employee_profile_url || "assets/profile-pic.png"}
                      className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                      alt="user-profile-picture"
                    /> */}
                    <span onClick={()=>{ employeeBasicData?.employee_profile_url && setViewProfile(true)}}>
                      <LazyImage src={`${employeeBasicData?.employee_profile_url || "assets/profile-pic.png"}`} 
                      alt="user-profile-picture" className="rounded-circle cursorPointer avatar-xl img-thumbnail user-profile-image" />
                    </span>
                  <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                    <input id="profile-img-file-input" type="file"  className="profile-img-file-input" onChange={handleFileChange} />
                    <label htmlFor="profile-img-file-input" className="profile-photo-edit avatar-xs">
                      <span className="avatar-title rounded-circle bg-light text-body">
                        <i className="ri-camera-fill" />
                      </span>
                    </label>
                  </div>
                </div>
                  <h5 className="fs-16 mb-1">{employeeBasicData?.employee_name}</h5>
                  <p className="text-muted mb-0">{employeeBasicData?.designation_title}</p>
                  <p className="text-muted mb-0">{employeeBasicData?.department_title}</p>
                </div>
              
              {viewProfile && (
                <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}}>
                    <div className=" m-auto mt-3 h-100 w-profilePic d-flex align-items-center justify-content-center">
                        <div className="modal-content">
                        <div className="modal-header pb-0">
                            <button
                            type="button"
                            onClick={()=>{ setViewProfile(false); }}
                            className="btn-close"
                            aria-label="Close"
                            />
                        </div>
                        <div className="modal-body py-0 d-flex align-items-center justify-content-center">
                          <div className="profile-container">
                            <img
                              src={employeeBasicData?.employee_profile_url}
                              alt="profile"
                            />
                          </div>
                        </div>                       
                        </div>
                    </div>
                </div>
              )}
              </div>
              {/* d-md-block d-none  */}
              <div className="">
                <div className="card mt-xxl-n5">
                  <div className="card-header overflow-x-auto overflow-y-hidden">
                    {/* nav nav-tabs-custom rounded card-header-tabs */}
                    <ul className=" d-md-flex d-none nav nav-tabs-custom d-flex align-items-center flex-nowrap gap-2 border-bottom-0 cursorPointer " role="tablist ">
                      {[
                        "BasicInformation",
                        "EmploymentInformation",
                        "FamilyDetails",
                        // "OfficialDocuments",
                        // "OtherPersonalDetails",
                        "BankDetails",
                        "PersonalDocuments",
                        "HolidayList",
                        // "SalaryDetails",
                        // "StatutoryDetails",
                      ].map((tab) => (
                        <li className="nav-item mb-1 " role="presentation" key={tab}>
                          <p
                            className={`nav-link mb-0 pb-3 noWrap ${activeComponent === tab ? "active" : ""}`}
                            onClick={() => setActiveComponent(tab)}
                          >
                            {tab.replace(/([A-Z])/g, " $1").trim()}
                          </p>
                        </li>
                      ))}
                    </ul>
                    <div className='d-md-none d-block position-relative mb-5'>
                        <div><label>Profile Details List</label></div>
                        <div style={{ "zIndex": 9, "width": "100%" }} className=' position-absolute'>
                            <Select onChange={(selectedOption) => setActiveComponent(selectedOption?.value)}
                            options={profileInfoOptions}
                            placeholder={`Select`}
                            value={activeComponent ? profileInfoOptions.find(option => option.value === activeComponent) : null}/>
                        </div>
                    </div>
                  </div>
                  <div style={{ minHeight:" 70vh" }} className="card-body">{renderComponent()}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "90vh" }}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfileDetails;
